import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Chip-style pickers for "languages spoken" and (optionally) "interpreter required for".
// Controlled: pass current arrays + onChange({ languages, interpreter_languages }).
// verifiedOnly: when true (interpreter accounts), only admin-verified languages are assignable.
export function LanguageFields({ languages = [], interpreterLanguages = [], onChange, showInterpreter = true, verifiedOnly = false }) {
  const [all, setAll] = useState([]);
  useEffect(() => { api.get("/languages").then(({ data }) => setAll(data)).catch(() => {}); }, []);
  const options = (verifiedOnly ? all.filter((l) => l.verified !== false) : all).map((l) => l.name);
  const toggle = (list, name) => (list.includes(name) ? list.filter((x) => x !== name) : [...list, name]);
  return (
    <div className="grid gap-3" data-testid="language-fields">
      <div>
        <span className="text-xs uppercase tracking-wider font-bold text-muted2">{verifiedOnly ? "Verified language proficiencies" : "Languages spoken"}</span>
        <div className="flex flex-wrap gap-2 mt-1.5">
          {options.map((n) => (
            <button type="button" key={n} data-testid={`lang-${n}`}
              onClick={() => onChange({ languages: toggle(languages, n), interpreter_languages: interpreterLanguages })}
              className={`text-sm rounded-full px-3 py-1 border transition-colors ${languages.includes(n) ? "bg-clinical text-white border-clinical" : "border-line text-muted2 hover:border-clinical/40"}`}>{n}</button>
          ))}
          {options.length === 0 && <span className="text-sm text-muted2">{verifiedOnly ? "No verified languages available. Verify a language under Settings → Languages." : "No languages configured yet."}</span>}
        </div>
      </div>
      {showInterpreter && (
        <div>
          <span className="text-xs uppercase tracking-wider font-bold text-muted2">Interpreter required for</span>
          <div className="flex flex-wrap gap-2 mt-1.5">
            {options.map((n) => (
              <button type="button" key={n} data-testid={`interp-${n}`}
                onClick={() => onChange({ languages, interpreter_languages: toggle(interpreterLanguages, n) })}
                className={`text-sm rounded-full px-3 py-1 border transition-colors ${interpreterLanguages.includes(n) ? "bg-alert text-white border-alert" : "border-line text-muted2 hover:border-alert/40"}`}>{n}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
